import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { patchCustomTheme } from 'redux/themes/actions';
import { avatarStyles } from './avatar-styles';
import CustomAvatarStyleItem
  from 'components/dashboard/appearance-content/CustomAvatarStyleItem';

import './CustomAvatarStyleSelector.css';

class CustomAvatarStyleSelector extends Component {
  static propTypes = {
    me: PropTypes.object,
    patchCustomTheme: PropTypes.func.isRequired,
    setCustomMode: PropTypes.func.isRequired,
  };
  static defaulpProps = {
    me: null,
  };

  state = {
    currentAvatarStyle: null,
  };

  componentDidMount() {
    const { me } = this.props;
    if (me && me.custom_theme) {
      this.setState({ currentAvatarStyle: me.custom_theme.avatar_style });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.me && this.props.me.custom_theme &&
      this.props.me.custom_theme != prevProps.me.custom_theme
    ) {
      this.setState({ currentAvatarStyle: this.props.me.custom_theme.avatar_style });
    }
  }

  onPatchCustomTheme = (parameter, value) => {
    const { me } = this.props;
    const customThemeId = me && me.custom_theme && me.custom_theme.id;
    const form = new FormData();
    form.append(parameter, value);
    this.props.patchCustomTheme(customThemeId, form);
  };

  onAvatarSelectorChange = item => {
    // this line is commented out as styling avatars is not related to styling themes
    // if (this.props.me.theme) { this.props.setCustomMode(); }
    this.onPatchCustomTheme('avatar_style', item);
    this.setState({ currentAvatarStyle: item });
  };

  render() {
    const { me } = this.props;
    return (
      <div className="custom-avatar-style-selector__component">
        {avatarStyles && avatarStyles.map(item => (
          <CustomAvatarStyleItem
            key={`custom_avatar_style_key_${item.value}`}
            avatarType={item.value}
            active={item.value === this.state.currentAvatarStyle}
            onClick={() => this.onAvatarSelectorChange(item.value) }
            me={me}
            item={item}
          />
        ))}
      </div>
    );
  }
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
  }
);

export default connect(
  mapStateToProps,
  {
    patchCustomTheme,
  },
)(CustomAvatarStyleSelector);
